module.exports = __webpack_public_path__ + "img/png_jsgzl_4@2x.7501deb0.png";